import { render, staticRenderFns } from "./gettingStart.vue?vue&type=template&id=b3dab0ac&scoped=true&"
import script from "./gettingStart.vue?vue&type=script&lang=js&"
export * from "./gettingStart.vue?vue&type=script&lang=js&"
import style0 from "./gettingStart.vue?vue&type=style&index=0&id=b3dab0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dab0ac",
  null
  
)

export default component.exports